import React, { Component } from 'react';
import {
  Text,
  View,
  TextInput,
  Alert,
  StyleSheet,
  ScrollView,
  TouchableOpacity,
} from 'react-native';
import PropTypes from 'prop-types';
import codePush from 'react-native-code-push';
import dismissKeyboard from 'react-native-dismiss-keyboard';
import { globalStyles } from 'app/styles/global';
import { NAME_PATTERN } from 'app/utils/text';
import { colors } from 'styles';

let localStyles;
let styles;

class SignUp extends Component {
  static propTypes = {
    auth: PropTypes.object,
    actions: PropTypes.object,
    navigation: PropTypes.object,
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      message: '',
      name: '',
      email: '',
      password: '',
      cPassword: '',
      identityToken: null,
      nameError: null,
      emailError: null,
    };
  }

  componentDidMount() {
    const params = this.props.navigation?.state?.params;
    if (this.props.auth.preUser) {
      const { name, email, password, identityToken } = this.props.auth.preUser;
      this.setState({
        name,
        email,
        password,
        cPassword: password,
        identityToken,
      });
    }
    if (params && params.email) {
      this.setState({
        email: params.email.trim(),
        code: params.code,
      });
      setTimeout(async () => {
        const emailError = await this.checkEmail();
        if (emailError) Alert.alert(emailError);
      }, 100);
    }
    codePush.disallowRestart();
  }

  componentDidUpdate(prev) {
    const { auth } = this.props;
    if (auth.preUser && prev.auth.preUser !== auth.preUser) {
      this.setState({
        name: auth.preUser.name || null,
        phone: auth.preUser.phone || null,
        email: auth.preUser.email || null,
        password: auth.preUser.password || null,
        cPassword: auth.preUser.password || null,
      });
    }
  }

  checkEmail = async () => {
    const string = this.state.email;
    const { actions } = this.props;

    const valid = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(string);
    if (!valid) {
      const emailError = 'invalid email';
      this.setState({ emailError: 'invalid email' });
      return emailError;
    }

    const emailExists = await actions.checkUser(string, 'email');
    if (emailExists) {
      const emailError = 'This email has already been used - try logging in';
      this.setState({ emailError });
      return emailError;
    }

    return null;
  };

  checkUser = async (_name) => {
    const { actions } = this.props;
    const name = _name || this.state.name;
    if (!name) return;
    const match = NAME_PATTERN.test(name);
    if (!match) {
      const nameError =
        'username can only contain letters, numbers, dashes and underscores';
      this.setState({ nameError });
      return nameError;
    }
    const userExist = await actions.checkUser(name, 'name');
    if (userExist) {
      const nameError = 'This username is already taken';
      this.setState({ nameError });
      return nameError;
    }
    this.setState({ nameError: null });
  };

  validate = async () => {
    const { email, name, password, emailError, cPassword, identityToken } = this.state;
    const { actions } = this.props;

    if (!name || !name.length)
      return Alert.alert('You must chose a username in order to create an account');

    const nameError = await this.checkUser();
    if (nameError) return Alert.alert(nameError);

    if (!NAME_PATTERN.test(name))
      return Alert.alert(
        'username can only contain letters, numbers, dashes and underscores'
      );

    if (name.length > 15) return Alert.alert('name must be less than 15 characters');

    if (!email && !identityToken) return Alert.alert('email required');

    if (!identityToken && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
      return Alert.alert('invalid email address');
    }

    if (emailError) return Alert.alert(emailError);

    if (password) {
      if (password !== cPassword) return Alert.alert("Passwords don't match");
    } else if (!identityToken) {
      return Alert.alert('Password required');
    }

    const user = { email, name, password, identityToken };

    actions.setPreUser(user);
    dismissKeyboard();
    actions.push({
      key: 'imageUpload',
      title: 'image',
    });

    return null;
  };

  render() {
    styles = { ...localStyles, ...globalStyles };
    const { identityToken, nameError } = this.state;

    return (
      <ScrollView
        keyboardDismissMode={'interactive'}
        keyboardShouldPersistTaps={'always'}
        style={{ flex: 1 }}
        contentContainerStyle={styles.authScrollContent}
      >
        <View style={styles.fieldsInner}>
          <View style={styles.fieldsInputParent}>
            <TextInput
              underlineColorAndroid={'transparent'}
              autoCapitalize={'none'}
              autoCorrect={false}
              keyboardType={'default'}
              clearTextOnFocus={false}
              placeholderTextColor={colors.grey}
              placeholder="username"
              onBlur={() => this.checkUser(this.state.name)}
              onChangeText={(name) => {
                this.setState({ name: name.trim(), nameError: null });
              }}
              value={this.state.name}
              style={styles.fieldsInput}
            />
          </View>
          {nameError ? (
            <Text style={[styles.smallInfo, styles.error]}>{nameError}</Text>
          ) : null}
          {!identityToken ? (
            <View style={styles.fieldsInputParent}>
              <TextInput
                underlineColorAndroid={'transparent'}
                autoCapitalize={'none'}
                autoCorrect={false}
                keyboardType={'email-address'}
                clearTextOnFocus={false}
                placeholderTextColor={colors.grey}
                placeholder="email"
                onBlur={() => this.checkEmail()}
                onChangeText={(email) =>
                  this.setState({ email: email.trim(), emailError: null })
                }
                value={this.state.email}
                style={styles.fieldsInput}
              />
            </View>
          ) : null}
          {this.state.emailError ? (
            <Text style={[styles.smallInfo, styles.error]}>{this.state.emailError}</Text>
          ) : null}

          {!identityToken ? (
            <View>
              <View style={styles.fieldsInputParent}>
                <TextInput
                  underlineColorAndroid={'transparent'}
                  autoCapitalize={'none'}
                  secureTextEntry
                  keyboardType={'default'}
                  placeholderTextColor={colors.grey}
                  placeholder="password"
                  onChangeText={(password) => this.setState({ password })}
                  value={this.state.password}
                  style={styles.fieldsInput}
                />
              </View>

              <View style={styles.fieldsInputParent}>
                <TextInput
                  underlineColorAndroid={'transparent'}
                  autoCapitalize={'none'}
                  secureTextEntry
                  keyboardType={'default'}
                  clearTextOnFocus={false}
                  placeholderTextColor={colors.grey}
                  placeholder="confirm password"
                  onChangeText={(cPassword) => this.setState({ cPassword })}
                  value={this.state.cPassword}
                  style={styles.fieldsInput}
                />
              </View>
            </View>
          ) : null}
        </View>

        <TouchableOpacity
          style={[styles.largeButton, { marginTop: 20 }]}
          onPress={this.validate}
        >
          <Text style={styles.largeButtonText}>next</Text>
        </TouchableOpacity>

        <TouchableOpacity
          onPress={() =>
            this.props.actions.goToUrl('https://relevant.community/eula.html')
          }
        >
          <Text style={[styles.signInText, styles.font12]}>
            By signing up, you agree to our{' '}
            <Text style={[styles.signInText, styles.active, styles.font12]}>
              Terms of Use
            </Text>
          </Text>
        </TouchableOpacity>
      </ScrollView>
    );
  }
}

localStyles = StyleSheet.create({
  error: {
    marginTop: 5,
    color: 'red',
    textAlign: 'center',
  },
});

styles = { ...globalStyles, ...localStyles };

export default SignUp;
